(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/assets/javascripts/pages/page-lobby.js') >= 0) return;  svs.modules.push('/modules/bingo-react/assets/javascripts/pages/page-lobby.js');
"use strict";


const WidgetArea = svs.components.lbUtils.widgetArea.WidgetArea;
const StaticWidgetArea = svs.bingo_react.components.common.constants.StaticWidgetArea;
const PageHeader = svs.bingo_react.components.page_header.PageHeader;
const useCheckParams = svs.bingo_react.components.useCheckParams;
const BingoGrid = svs.bingo_react.components.bingoGrid.BingoGrid;
const BingoLobby = _ref => {
  let headerConfig = _ref.headerConfig;
  useCheckParams();
  return React.createElement("main", {
    className: "bingo-main-content-container"
  }, React.createElement(PageHeader, {
    fallbackConfig: {
      header: 'Vilken svensk klassiker väljer du?'
    },
    headerConfig: headerConfig
  }), React.createElement(WidgetArea, {
    widgetArea: StaticWidgetArea.BingoLobbyTickerArea
  }), React.createElement(BingoGrid, null), React.createElement("section", null, React.createElement(WidgetArea, {
    widgetArea: StaticWidgetArea.BingoLobby
  })));
};
setGlobal('svs.bingo_react.pages.BingoLobby', BingoLobby);

 })(window);